import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import * as THREE from 'three';
import { BLANK_W, TILE_D, TILE_H } from '../lib/layout';
import { useLabelFactor } from './sceneHooks';
const GEO = new THREE.BoxGeometry(BLANK_W, TILE_H, TILE_D);
const EDGES = new THREE.EdgesGeometry(GEO);
const {
  damp
} = THREE.MathUtils;

/** The next token's empty slot at the end of the row. */
export function BlankTile({
  x,
  visible,
  reducedMotion
}: {
  x: number;
  visible: boolean;
  reducedMotion: boolean;
}) {
  const labelFactor = useLabelFactor();
  const groupRef = useRef<THREE.Group>(null);
  const fillRef = useRef<THREE.MeshBasicMaterial>(null);
  const edgeRef = useRef<THREE.LineBasicMaterial>(null);
  const initialPos = useRef<[number, number, number]>([x, TILE_H / 2, 0]).current;
  useFrame((state, delta) => {
    const group = groupRef.current;
    if (!group) return;
    const d = Math.min(delta, 0.05);
    group.position.x = damp(group.position.x, x, 4.2, d);
    const s = damp(group.scale.x, visible ? 1 : 0.0001, 6, d);
    group.scale.setScalar(s);
    group.visible = s > 0.01;
    const breathe = reducedMotion ? 0.5 : 0.5 + 0.5 * Math.sin(state.clock.elapsedTime * 2.2);
    if (fillRef.current) fillRef.current.opacity = 0.04 + 0.06 * breathe;
    if (edgeRef.current) edgeRef.current.opacity = 0.35 + 0.4 * breathe;
  });
  return <group ref={groupRef} position={initialPos} scale={0.0001} data-id="element-29" data-mp="36mis4657teyx">
      <mesh geometry={GEO} raycast={() => null} data-id="element-30" data-mp="36o3m9unmavw9">
        <meshBasicMaterial ref={fillRef} color="#FFFFFF" transparent opacity={0.06} depthWrite={false} data-id="element-31" data-mp="3bkartmc3q5do" />
      </mesh>
      <lineSegments geometry={EDGES} raycast={() => null} data-id="element-32" data-mp="3kliet8963jsg">
        <lineBasicMaterial ref={edgeRef} color="#FFFFFF" transparent opacity={0.5} data-id="element-33" data-mp="3kkz8kosvqju9" />
      </lineSegments>
      {visible && <Html center position={[0, 0, TILE_D / 2 + 0.01]} distanceFactor={8 * labelFactor} zIndexRange={[10, 0]} wrapperClass="pointer-events-none" className="pointer-events-none" data-id="element-34" data-mp="1q7ramo9lxs4e">
          <span className="select-none font-mono text-[20px] font-semibold text-white/85 animate-[fadeIn_0.6s_ease_both]" data-id="element-35" data-mp="2okvg3vi1520e">
            ?
          </span>
        </Html>}
    </group>;
}